export function getTiptapMentionsFromHTML(htmlContent: string): { id: string; label?: string }[] {
	try {
		const parser = new DOMParser();
		const doc = parser.parseFromString(htmlContent, 'text/html');
		const mentionElements = doc.querySelectorAll('[data-type="mention"]');

		return Array.from(mentionElements).map((el) => ({
			id: el.getAttribute('data-id') ?? '',
			label: el.getAttribute('data-label') ?? '',
		}));
	} catch (error) {
		console.error('Error extracting mentions from HTML:', error);
		return [];
	}
}

/** Strips trailing empty paragraphs (e.g., <p><br></p>, <p></p>) from HTML content */
export function stripTrailingEmptyParagraphs(html: string): string {
	if (!html) return html;
	return html.replace(/(<p>(<br\s*\/?>|<br\s+[^>]*\/?>|\s)*<\/p>\s*)+$/gi, '');
}

export function parseTextToReplaceMentions(
	text: string,
	mentionedUsers: { email: string; name: string }[]
) {
	try {
		const parser = new DOMParser();
		const doc = parser.parseFromString(text, 'text/html');
		const mentionElements = doc.querySelectorAll('[data-type="mention"]');
		mentionElements.forEach((el) => {
			const mentionedUser = mentionedUsers.find(
				(user) => user.email === el.getAttribute('data-id')
			);
			if (mentionedUser) {
				el.innerHTML = `${mentionedUser.name || mentionedUser.email}`;
				el.setAttribute('data-label', mentionedUser.name || mentionedUser.email);
			}
		});

		return doc.body.innerHTML || '';
	} catch (err) {
		console.error('Error in parseTextToReplaceMentions', err);
		return text;
	}
}
